/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Organization { 
    readonly id: number;
    /**
     * Official name of the company.
     */
    companyName: string;
    /**
     * The name of the person which is eligible to perform legal actions in the name of the company. Compulsory parameter for all organizations. Owner, legal representative, CEO...
     */
    representative: string;
    /**
     * Represents a unique identification of the subject, e.g. ICO, SIRET...
     */
    realWorldId?: string | null;
}

